import axios from '../config/axios';

import type { ObleaConfiguracion } from '../interfaces/obleaConfiguracion';

const PATH = `oblea-configuracion`;

/**
 * @description Recupera desde la API la configuración institucional de la oblea
 * @returns {Promise<ObleaConfiguracion>} Configuración de la oblea
 */
export const getObleaConfiguracion = async () => {
  return await axios.get<{ data: ObleaConfiguracion }>(PATH).then((response) => {
    return response.data.data;
  });
};
